export default "__VITE_ASSET__DJBy_5AE__"